import * as React from 'react';
import { Microfrontend } from '@cian/mf-react';

import { IWidgetManifest } from '../../../ServicePickerWidget/types/widgetManifest';
import { useAppContext } from '../../../AppModulesWrapper';

import { usePayPackageMicrofrontendEvents } from './hooks';

export const PayPackageMicrofrontend = () => {
  const { config, logger } = useAppContext();

  usePayPackageMicrofrontendEvents();

  const manifest = config.get<IWidgetManifest>('payPackageManifest');

  if (!manifest) {
    logger.error('Отсутствует манифест микрофронта Модалки покупки пакета', {
      domain: 'microfrontends.buy-package.manifest',
    });

    return null;
  }

  return <Microfrontend {...manifest} />;
};
